import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const propTypes = {
  header: PropTypes.string,
  message: PropTypes.string
};

class ErrorMessage extends Component {
  capitalizedField = fieldName => fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
  decamelizeField = fieldName => fieldName.replace(/([a-z])([A-Z])/g, '$1 $2');

  render() {
    const { header, message } = this.props;
    let headers;

    if (header) {
      headers = header.split('.').map(h => this.decamelizeField(this.capitalizedField(h)));
    }

    return (
      <div className="toast-body-wrapper">
        <div className="toast-icon-wrapper">
          <span className="toast-icon__error"></span>
        </div>
        <div>
          {headers && <strong>{headers.join(' - ')}</strong>}
          <div>{message}</div>
        </div>
      </div>
    );
  }
}

ErrorMessage.protoTypes = propTypes;

export default ErrorMessage;
